import { render, staticRenderFns } from "./TemplatesLibrary.vue?vue&type=template&id=170b4166&scoped=true"
import script from "./TemplatesLibrary.vue?vue&type=script&lang=js"
export * from "./TemplatesLibrary.vue?vue&type=script&lang=js"
import style0 from "./TemplatesLibrary.vue?vue&type=style&index=0&id=170b4166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b4166",
  null
  
)

export default component.exports